(function(){
  var toggle=document.querySelector('[data-nav-toggle]');
  var nav=document.querySelector('[data-nav]');
  if(toggle&&nav){
    toggle.addEventListener('click',function(){
      var open=!document.body.classList.contains('nav-open');
      document.body.classList.toggle('nav-open',open);
      toggle.setAttribute('aria-expanded',open?'true':'false');
    });
    nav.addEventListener('click',function(event){
      if(event.target.closest('a')){
        document.body.classList.remove('nav-open');
        toggle.setAttribute('aria-expanded','false');
      }
    });
  }

  function toast(message){
    var el=document.querySelector('.toast');
    if(!el){
      el=document.createElement('div');
      el.className='toast';
      document.body.appendChild(el);
    }
    el.textContent=message;
    el.classList.add('is-visible');
    clearTimeout(el._timer);
    el._timer=setTimeout(function(){el.classList.remove('is-visible');},2600);
  }

  function updateCartCount(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(res){return res.json();})
      .then(function(cart){
        document.querySelectorAll('[data-cart-count]').forEach(function(el){
          el.textContent=cart.item_count;
        });
      })
      .catch(function(){});
  }

  (function handlePaymentReturn(){
    try{
      var params=new URLSearchParams(window.location.search);
      var status=params.get('sp_payment');
      var oid=params.get('oid');
      if(status&&oid&&window.location.pathname.indexOf('/pages/kupljeno')!==0){
        window.location.href='/pages/kupljeno?oid='+encodeURIComponent(oid)+'&sp_payment='+encodeURIComponent(status);
        return;
      }
    }catch(e){}
  
  var productGallery=document.querySelector('[data-product-gallery]');
  if(productGallery){
    var productSlides=[].slice.call(productGallery.querySelectorAll('[data-gallery-slide]'));
    var productThumbs=[].slice.call(productGallery.querySelectorAll('[data-gallery-thumb]'));
    var productPrev=document.getElementById('productGalleryPrev');
    var productNext=document.getElementById('productGalleryNext');
    function activeProductIndex(){
      var idx=productSlides.findIndex(function(slide){return slide.classList.contains('is-active');});
      return idx<0?0:idx;
    }
    function showProductIndex(index){
      if(!productSlides.length)return;
      var next=(index+productSlides.length)%productSlides.length;
      productSlides.forEach(function(slide,i){slide.classList.toggle('is-active',i===next);});
      productThumbs.forEach(function(thumb,i){thumb.classList.toggle('is-active',i===next);});
      if(productThumbs[next]&&productThumbs[next].scrollIntoView){
        productThumbs[next].scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
      }
    }
    productThumbs.forEach(function(thumb,i){thumb.addEventListener('click',function(){showProductIndex(i);});});
    if(productPrev)productPrev.addEventListener('click',function(){showProductIndex(activeProductIndex()-1);});
    if(productNext)productNext.addEventListener('click',function(){showProductIndex(activeProductIndex()+1);});
    var startX=0,startY=0;
    productGallery.addEventListener('touchstart',function(event){
      if(!event.touches||!event.touches.length)return;
      startX=event.touches[0].clientX;startY=event.touches[0].clientY;
    },{passive:true});
    productGallery.addEventListener('touchend',function(event){
      if(!event.changedTouches||!event.changedTouches.length)return;
      var dx=event.changedTouches[0].clientX-startX;
      var dy=event.changedTouches[0].clientY-startY;
      if(Math.abs(dx)<=Math.abs(dy)||Math.abs(dx)<40)return;
      showProductIndex(activeProductIndex()+(dx<0?1:-1));
    },{passive:true});
  }

})();


  document.querySelectorAll('[data-payment-form]').forEach(function(form){
    var errorBox=form.querySelector('[data-cart-form-error]');
    var controls=[].slice.call(form.querySelectorAll('[required]'));
    var attempted=false;
    function fieldLabel(control){
      return control.getAttribute('data-field-label')||control.name||'Polje';
    }
    function fieldWrap(control){
      return control.closest('.cart-field')||control.closest('.cart-terms');
    }
    function mark(control, invalid){
      var wrap=fieldWrap(control);
      if(wrap)wrap.classList.toggle('is-invalid',invalid);
      control.setAttribute('aria-invalid',invalid?'true':'false');
    }
    function validateControl(control){
      var invalid=false;
      if(control.type==='checkbox'){
        invalid=!control.checked;
      }else if(control.tagName==='SELECT'){
        invalid=!control.value;
      }else{
        invalid=!control.value.trim()||!control.checkValidity();
      }
      mark(control,invalid);
      return invalid;
    }
    function clearError(){
      if(errorBox){
        errorBox.hidden=true;
        errorBox.innerHTML='';
      }
    }
    function collectMissing(){
      var missing=[];
      controls.forEach(function(control){
        if(validateControl(control))missing.push(fieldLabel(control));
      });
      return missing.filter(function(item,index){return missing.indexOf(item)===index;});
    }
    function renderErrors(missing,scroll){
      if(!errorBox)return;
      if(!missing.length){
        clearError();
        return;
      }
      errorBox.hidden=false;
      errorBox.innerHTML='<strong>Molimo popunite obavezna polja:</strong><ul>'+missing.map(function(item){return '<li>'+item+'</li>';}).join('')+'</ul>';
      if(scroll)errorBox.scrollIntoView({behavior:'smooth',block:'center'});
    }
    controls.forEach(function(control){
      ['input','change'].forEach(function(type){
        control.addEventListener(type,function(){
          if(!attempted)return;
          renderErrors(collectMissing(),false);
        });
      });
    });
    form.addEventListener('submit',function(event){
      attempted=true;
      var missing=collectMissing();
      if(!missing.length){
        clearError();
        return;
      }
      event.preventDefault();
      renderErrors(missing,true);
      var first=form.querySelector('.is-invalid input,.is-invalid select,.is-invalid textarea');
      if(first)first.focus({preventScroll:true});
    });
  });

  document.querySelectorAll('.product-form').forEach(function(form){
    var actions=form.querySelector('.product-actions')||form;
    var submit=form.querySelector('button[type="submit"],input[type="submit"]');
    if(submit){
      if(submit.tagName==='INPUT')submit.value='Dodaj u korpu';
      else submit.textContent='Dodaj u korpu';
    }

    var controls=[].slice.call(actions.querySelectorAll('button,a,input[type="button"],input[type="submit"]'));
    var cartControl=null;
    controls.forEach(function(control){
      if(control===submit)return;
      var text=(control.textContent||control.value||'').replace(/\s+/g,' ').trim().toLowerCase();
      if(!cartControl&&(text.indexOf('korpu')!==-1||control.classList.contains('product-cart-link'))){
        cartControl=control;
      }
    });
    if(!cartControl&&submit&&submit.parentNode){
      cartControl=document.createElement('a');
      cartControl.className='button button--solid product-cart-link';
      submit.parentNode.appendChild(cartControl);
    }
    if(cartControl){
      if(cartControl.tagName==='A'){
        cartControl.setAttribute('href','/cart');
        cartControl.setAttribute('role','button');
      }else{
        cartControl.setAttribute('type','button');
      }
      cartControl.classList.add('product-cart-link');
      if(cartControl.tagName==='INPUT')cartControl.value='Otvori korpu';
      else cartControl.textContent='Otvori korpu';
      cartControl.addEventListener('click',function(event){
        event.preventDefault();
        window.location.href='/cart';
      });
    }
  });

  document.querySelectorAll('[data-quick-add]').forEach(function(form){
    form.addEventListener('submit',function(event){
      event.preventDefault();
      var button=form.querySelector('button[type="submit"]');
      if(button)button.disabled=true;
      fetch('/cart/add.js',{
        method:'POST',
        headers:{'Accept':'application/json'},
        body:new FormData(form)
      })
        .then(function(res){
          if(!res.ok)throw new Error('Cart error');
          return res.json();
        })
        .then(function(){
          updateCartCount();
          toast('Kreacija je dodata u korpu.');
        })
        .catch(function(){
          form.submit();
        })
        .finally(function(){
          if(button)button.disabled=false;
        });
      });
  });

  document.querySelectorAll('[data-product-gallery]').forEach(function(gallery){
    var slides=Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
    var thumbs=Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var current=0;

    function playActiveVideo(slide){
      if(!slide)return;
      slide.querySelectorAll('video').forEach(function(video){
        try{
          video.currentTime=0;
          var result=video.play();
          if(result&&typeof result.catch==='function')result.catch(function(){});
        }catch(e){}
      });
    }

    function show(index){
      if(!slides.length)return;
      current=(index+slides.length)%slides.length;
      slides.forEach(function(slide,i){
        if(i!==current){
          slide.querySelectorAll('video').forEach(function(video){
            try{video.pause();}catch(e){}
          });
        }
        slide.classList.toggle('is-active',i===current);
      });
      thumbs.forEach(function(thumb,i){
        thumb.classList.toggle('is-active',i===current);
        thumb.setAttribute('aria-current',i===current?'true':'false');
      });
      if(thumbs[current]){
        thumbs[current].scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
      }
      playActiveVideo(slides[current]);
    }

    thumbs.forEach(function(thumb){
      thumb.addEventListener('click',function(){
        show(Number(thumb.getAttribute('data-gallery-index')));
      });
    });

    var previous=gallery.querySelector('[data-gallery-prev]');
    var next=gallery.querySelector('[data-gallery-next]');
    if(previous)previous.addEventListener('click',function(){show(current-1);});
    if(next)next.addEventListener('click',function(){show(current+1);});

    var stage=gallery.querySelector('.product-gallery__stage');
    if(stage&&slides.length>1){
      var touchStartX=0;
      var touchStartY=0;
      stage.addEventListener('touchstart',function(e){
        touchStartX=e.touches[0].clientX;
        touchStartY=e.touches[0].clientY;
      },{passive:true});
      stage.addEventListener('touchend',function(e){
        var dx=e.changedTouches[0].clientX-touchStartX;
        var dy=e.changedTouches[0].clientY-touchStartY;
        if(Math.abs(dx)>Math.abs(dy)&&Math.abs(dx)>40){
          show(dx<0?current+1:current-1);
        }
      },{passive:true});
    }
  });

  /* ---- Description "more" toggle (mobile) ---- */
  var moreToggle=document.querySelector('[data-more-toggle]');
  if(moreToggle){
    moreToggle.addEventListener('click',function(){
      var content=document.getElementById(moreToggle.getAttribute('aria-controls'));
      var label=moreToggle.querySelector('[data-more-label]');
      var expanded=moreToggle.getAttribute('aria-expanded')==='true';
      expanded=!expanded;
      moreToggle.setAttribute('aria-expanded',expanded?'true':'false');
      if(content){content.hidden=!expanded;}
      if(label){label.textContent=expanded?'Manje ↑':'Više ↓';}
    });
  }

  /* ---- Product dialog ---- */
  var dialog=document.getElementById('spDialog');
  var stageMedia=document.getElementById('spStageMedia');
  var thumbsEl=document.getElementById('spThumbs');
  var prevBtn=document.getElementById('spPrev');
  var nextBtn=document.getElementById('spNext');
  var typeEl=document.getElementById('spType');
  var titleEl=document.getElementById('spTitle');
  var priceEl=document.getElementById('spPrice');
  var descEl=document.getElementById('spDesc');
  var variantsEl=document.getElementById('spVariants');
  var addBtn=document.getElementById('spAddBtn');
  var buyBtn=document.getElementById('spBuyBtn');
  var relatedGrid=document.getElementById('spRelatedGrid');
  var closeBtn=document.getElementById('spDialogClose');

  var currentMedia=[];
  var currentIndex=0;
  var currentVariantId=null;
  var allProductsEl=document.getElementById('sp-all-products');
  var allProducts=[];
  if(allProductsEl){
    try{allProducts=JSON.parse(allProductsEl.textContent);}catch(e){allProducts=[];}
  }

  function isEnglish(){
    return false;
  }

  function setSlide(index){
    if(!currentMedia.length)return;
    var nextIndex=(index+currentMedia.length)%currentMedia.length;
    var item=currentMedia[nextIndex];

    function activate(){
      currentIndex=nextIndex;
      if(stageMedia){
        stageMedia.querySelectorAll('video').forEach(function(video){
          try{video.pause();}catch(e){}
        });
        stageMedia.innerHTML=item.html||'';
        stageMedia.classList.remove('is-loading');
        stageMedia.querySelectorAll('video').forEach(function(video){
          try{
            video.currentTime=0;
            var result=video.play();
            if(result&&typeof result.catch==='function')result.catch(function(){});
          }catch(e){}
        });
      }
      if(thumbsEl){
        Array.prototype.forEach.call(thumbsEl.children,function(thumb,i){
          thumb.classList.toggle('is-active',i===currentIndex);
          thumb.setAttribute('aria-current',i===currentIndex?'true':'false');
        });
      }
    }

    if(!stageMedia){
      activate();
      return;
    }
    if(item.type&&item.type!=='image'){
      stageMedia.classList.add('is-loading');
      activate();
      return;
    }

    var match=(item.html||'').match(/<img[^>]+src="([^"]+)"/i);
    var src=match?match[1]:'';
    if(!src){
      activate();
      return;
    }

    stageMedia.classList.add('is-loading');
    var img=new Image();
    var done=false;
    function finish(){
      if(done)return;
      done=true;
      activate();
    }
    img.onload=finish;
    img.onerror=finish;
    img.src=src;
    if(img.complete)finish();
    setTimeout(finish,5000);
  }
  window.setSlide=setSlide;

  function buildVariants(data){
    if(!variantsEl)return;
    variantsEl.innerHTML='';
    var variants=data.variants||[];
    if(variants.length<=1||(variants.length===1&&variants[0].title==='Default Title')){
      currentVariantId=variants.length?variants[0].id:null;
      return;
    }
    var label=document.createElement('label');
    label.className='variant-label';
    label.textContent=isEnglish()?'Variant':'Varijanta';
    var select=document.createElement('select');
    variants.forEach(function(variant){
      var option=document.createElement('option');
      option.value=variant.id;
      option.textContent=variant.title+(variant.available?'':' (Rasprodato)');
      if(!variant.available)option.disabled=true;
      select.appendChild(option);
    });
    select.addEventListener('change',function(){
      currentVariantId=select.value;
    });
    variantsEl.appendChild(label);
    variantsEl.appendChild(select);
    currentVariantId=select.value;
  }

  function buildRelated(handle){
    if(!relatedGrid)return;
    relatedGrid.innerHTML='';
    allProducts
      .filter(function(p){return p.handle!==handle;})
      .slice(0,4)
      .forEach(function(p){
        var item=document.createElement('button');
        item.type='button';
        item.className='sp-related__item';
        item.setAttribute('aria-label',p.title);
        var img=document.createElement('img');
        img.src=p.thumb;
        img.alt=p.title;
        item.appendChild(img);
        item.addEventListener('click',function(){openProductDialog(p.handle);});
        relatedGrid.appendChild(item);
      });
  }

  function openProductDialog(handle){
    if(!dialog)return;
    var script=document.querySelector('.sp-product-json[data-sp-handle="'+handle+'"]');
    if(!script)return;
    var data;
    try{data=JSON.parse(script.textContent);}catch(e){return;}

    if(typeEl)typeEl.textContent=data.type||'';
    if(titleEl)titleEl.textContent=data.title;
    if(priceEl){
      priceEl.innerHTML=data.on_sale
        ?'<span class="price--sale">'+data.price+'</span> <s class="price--compare">'+data.compare_at_price+'</s>'
        :data.price;
    }
    if(descEl)descEl.textContent=data.description;

    if(data.media&&data.media.length){
      currentMedia=data.media;
    }else{
      currentMedia=((data.images&&data.images.length)?data.images:data.thumbs).map(function(src,i){
        return {type:'image',html:'<img src="'+src+'" alt="">',thumb:(data.thumbs&&data.thumbs[i])||src};
      });
    }
    if(thumbsEl){
      thumbsEl.innerHTML='';
      currentMedia.forEach(function(item,i){
        var thumb=document.createElement('button');
        thumb.type='button';
        thumb.className='sp-gallery__thumb'+(item.type&&item.type!=='image'?' has-media':'');
        var img=document.createElement('img');
        img.src=item.thumb||'';
        img.alt='';
        thumb.appendChild(img);
        if(item.type&&item.type!=='image'){
          var badge=document.createElement('span');
          badge.className='media-badge';
          badge.textContent=item.type.replace('_',' ');
          thumb.appendChild(badge);
        }
        thumb.addEventListener('click',function(){setSlide(i);});
        thumbsEl.appendChild(thumb);
      });
    }
    setSlide(0);

    buildVariants(data);

    if(addBtn)addBtn.disabled=!data.available;
    if(buyBtn)buyBtn.disabled=!data.available;

    if(addBtn){
      addBtn.textContent='Dodaj u korpu';
      addBtn.onclick=function(){
        addToCart(currentVariantId,function(){
          toast('Kreacija je dodata u korpu.');
        });
      };
    }
    if(buyBtn){
      buyBtn.textContent='Otvori korpu';
      buyBtn.onclick=function(){
        window.location.href='/cart';
      };
    }

    buildRelated(handle);

    if(typeof dialog.showModal==='function'){
      dialog.showModal();
    }
  }
  window.openProductDialog=openProductDialog;

  function addToCart(variantId,onDone){
    if(!variantId)return;
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:variantId,quantity:1})
    })
      .then(function(res){
        if(!res.ok)throw new Error('Cart error');
        return res.json();
      })
      .then(function(){
        updateCartCount();
        if(onDone)onDone();
      })
      .catch(function(){
        toast('Došlo je do greške.');
      });
  }

  if(closeBtn&&dialog){
    closeBtn.addEventListener('click',function(){dialog.close();});
  }
  if(dialog){
    dialog.addEventListener('click',function(event){
      if(event.target===dialog)dialog.close();
    });
  }
  if(prevBtn)prevBtn.addEventListener('click',function(){setSlide(currentIndex-1);});
  if(nextBtn)nextBtn.addEventListener('click',function(){setSlide(currentIndex+1);});

  var dialogStageEl=dialog?dialog.querySelector('.sp-gallery__stage'):null;
  if(dialogStageEl){
    var dTouchX=0,dTouchY=0;
    dialogStageEl.addEventListener('touchstart',function(e){
      dTouchX=e.touches[0].clientX;
      dTouchY=e.touches[0].clientY;
    },{passive:true});
    dialogStageEl.addEventListener('touchend',function(e){
      var dx=e.changedTouches[0].clientX-dTouchX;
      var dy=e.changedTouches[0].clientY-dTouchY;
      if(Math.abs(dx)>Math.abs(dy)&&Math.abs(dx)>40){
        setSlide(dx<0?currentIndex+1:currentIndex-1);
      }
    },{passive:true});
  }

  document.documentElement.setAttribute('lang','sr');
})();
